export enum EventValues {
  lastLogin = 'last login',
  dataCreated = 'data created',
}
